// DETECTION TACTILE *************************************************************************
/**
 * Appareil tactile sans souris (tablette, telephone). Synchro CSS : meme condition
 * (hover: none) and (pointer: coarse) dans moon-moon.css.liquid pour forcer le menu mobile.
 */
const mmIsTouchDevice = () => window.matchMedia("(hover: none) and (pointer: coarse)").matches;

// LOADER ************************************************************************************
/**
 * Add a loading state to the specified button.
 *
 * @param {HTMLElement} elem - The element to which the 'mm-loading' class will be added.
 */
const mmLoadThis = (elem) => elem.classList.add("mm-loading");

// MEGAMENU **********************************************************************************
/**
 * Hide specified elements and show the specified element.
 *
 * @param {string} classElemsToHide - The CSS selector for the elements to hide.
 * @param {string} classElemToShow - The CSS selector for the element to show.
 */
const mmMegaMenuShowProducts = (classElemsToHide, classElemToShow) => {
	document.querySelectorAll(classElemsToHide).forEach((elem) => (elem.style.display = "none"));
	document.querySelector(classElemToShow).style.display = "grid";
};

/**
 * Adjust the position of the mega menu based on the header height.
 *
 */
const getMegaMenuPosition = () => {
	const header = document.querySelector("[data-mm-header]");
	if (!header) return;

	const headerHeight = header.offsetHeight;
	document.querySelectorAll("[data-megamenulink]").forEach((menuElem) => {
		const megaMenu = menuElem.nextElementSibling;
		if (megaMenu?.hasAttribute("data-megamenu")) {
			megaMenu.style.top = `${headerHeight - 1}px`;
		}
		if (megaMenu?.hasAttribute("data-megamenu-top")) {
			megaMenu.style.top = `47px`;
		}
	});
};

// BACKGROUND FILTER *************************************************************************
/**
 * Add background filter on hover over mega menu links.
 *
 */
const hoverBgFilter = () => {
	const header = document.querySelector("[data-mm-header]");
	const searchContainer = document.querySelector("[data-search-container]");
	const megaMenuLinks = document.querySelectorAll("[data-megamenulink]");
	const menuLinks = document.querySelectorAll("[data-menulink]");
	const filter = document.querySelector("[data-filter]");
	const cart = document.querySelector("[data-cart-filter]");

	if (!header || !filter || !cart) return;

	const toggleFilter = (show) => {
		filter.classList.toggle("active", show);
	};

	megaMenuLinks.forEach((link) => link.addEventListener("mouseenter", () => toggleFilter(true)));
	menuLinks.forEach((link) => link.addEventListener("mouseenter", () => toggleFilter(false)));

	header.addEventListener("mouseleave", () => {
		// Vérifier si la recherche prédictive est ouverte
		const predictiveSearchDefault = document.querySelector(".mm-ps-default");
		const predictiveSearch = document.querySelector(".mm-ps-results");
		const isSearchOpen = (predictiveSearchDefault && predictiveSearchDefault.style.display === 'flex') ||
							(predictiveSearch && predictiveSearch.style.display === 'block');

		if ((!searchContainer || !searchContainer.classList.contains("mm-open")) &&
			!cart.classList.contains("mm-dc-is-open") &&
			!isSearchOpen) {
			toggleFilter(false);
		}
	});
};

/**
 * Show background filter.
 *
 */
const showBgFilter = (zIndex) => {
	const filter = document.querySelector("[data-filter]");
	if (!filter) return;
	filter.classList.add("active");
	if (zIndex) filter.style.zIndex = zIndex;
};

/**
 * Hide background filter.
 *
 */
const hideBgFilter = () => {
	const filter = document.querySelector("[data-filter]");
	if (!filter) return;
	setTimeout(() => filter.style.removeProperty("z-index"), 700);
	filter.classList.remove("active");
};

// EXTERNAL LINK *****************************************************************************
/**
 * Open external links in a new tab unless it's the consent modale.
 *
 */
const externalLink = () => {
	document.querySelectorAll("a:not(.consent-wrapper)").forEach((link) => {
		if (link.hostname !== window.location.hostname) {
			link.target = "_blank";
			link.rel = "noreferrer noopener";
		}
	});
};

// MENU MOBILE *******************************************************************************
/**
 * Toggle the mobile menu.
 *
 */
const mmMobileMenu = () => {
  if (window.innerWidth > 1400 && !mmIsTouchDevice()) return;

  const elements = {
    header: document.querySelector("header"),
    icon: document.querySelector("[data-header-burger]"),
    mobileMenu: document.querySelector("[data-menu-mobile]"),
    mobileMenuInner: document.querySelector("[data-menu-mobile] > .mm-mobile-menu-container"),
    // ← récupère TOUS les blocs de sous-liens
    mobileMenuSecondaryList: Array.from(document.querySelectorAll("[data-menu-sublinks]")),
    headerMenu: document.querySelector("[data-mm-header]"),
    html: document.documentElement,
  };

  // on ne bloque pas si aucun [data-menu-sublinks] n'est présent
  const required = [
    elements.header,
    elements.icon,
    elements.mobileMenu,
    elements.mobileMenuInner,
    elements.headerMenu,
    elements.html,
  ];
  if (required.some((el) => !el)) return;

  const { header, icon, mobileMenu, mobileMenuInner, mobileMenuSecondaryList, headerMenu, html } = elements;

  const headerHeight = headerMenu.offsetHeight;
  const headerMenuTop = headerMenu.getBoundingClientRect().top;
  const topPosition = `${headerHeight + headerMenuTop}px`;
  const topPositionMinus = `-${headerHeight + headerMenuTop}px`;
  const heightCalc = `calc(var(--doc-height) - ${topPosition})`;

  [header, icon, mobileMenu].forEach((el) => el.classList.toggle("mm-open"));
  html.classList.add("stop-scrolling");
  mobileMenu.setAttribute('aria-hidden', 'false');
  icon.setAttribute('aria-expanded', 'true');

  Object.assign(mobileMenuInner.style, { height: heightCalc });
  Object.assign(mobileMenuInner.style, { top: topPosition });

  // applique le style à CHAQUE sous-menu
  mobileMenuSecondaryList.forEach((el) => {
    Object.assign(el.style, { top: topPositionMinus });
  });

  // Clavier : focus dans le menu, Tab bouclé entre le burger et le menu, Échap ferme
  // preventScroll : le panneau glisse encore, un focus avec scroll decalerait les conteneurs
  mmMobileMenuFocusables(mobileMenu)[0]?.focus({ preventScroll: true });
  document.addEventListener('keydown', mmMobileMenuKeydown);

  // showBgFilter("var(--index-lg)");
};

/**
 * Éléments focalisables réellement visibles du menu mobile (les niveaux
 * fermés ou recouverts sont en visibility: hidden, cf. mm-header.css).
 *
 * @param {HTMLElement} mobileMenu
 * @returns {HTMLElement[]}
 */
const mmMobileMenuFocusables = (mobileMenu) => {
  const selector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  return Array.from(mobileMenu.querySelectorAll(selector)).filter((el) =>
    el.checkVisibility ? el.checkVisibility({ visibilityProperty: true }) : el.offsetParent !== null
  );
};

/**
 * Piège de focus du menu mobile ouvert. Les bornes sont recalculées à chaque
 * Tab : elles changent quand un sous-menu s'ouvre ou se ferme.
 *
 * @param {KeyboardEvent} e
 */
const mmMobileMenuKeydown = (e) => {
  const icon = document.querySelector("[data-header-burger]");
  const mobileMenu = document.querySelector("[data-menu-mobile]");
  if (!icon || !mobileMenu) return;

  if (e.key === 'Escape') {
    mmCloseMobileMenu();
    icon.focus();
    return;
  }
  if (e.key !== 'Tab') return;

  // Le burger est hors du menu dans le DOM : le cycle est géré ici en entier
  const focusables = [icon, ...mmMobileMenuFocusables(mobileMenu)];
  const index = focusables.indexOf(document.activeElement);
  const step = e.shiftKey ? -1 : 1;
  const next = index === -1
    ? focusables[e.shiftKey ? focusables.length - 1 : 0]
    : focusables[(index + step + focusables.length) % focusables.length];

  e.preventDefault();
  next.focus();
};

/**
 * Ferme le menu mobile.
 */
const mmCloseMobileMenu = (keepFilterActive = false) => {
  if (window.innerWidth > 1400 && !mmIsTouchDevice()) return;

  const elements = {
    header: document.querySelector("header"),
    icon: document.querySelector("[data-header-burger]"),
    mobileMenu: document.querySelector("[data-menu-mobile]"),
    // on récupère aussi tous les sous-menus pour éventuellement nettoyer
    mobileMenuSecondaryList: Array.from(document.querySelectorAll("[data-menu-sublinks]")),
    html: document.documentElement,
  };

  const required = [elements.header, elements.icon, elements.mobileMenu, elements.html];
  if (required.some((el) => !el)) return;

  const { header, icon, mobileMenu, mobileMenuSecondaryList, html } = elements;

  // Focus dans le menu qui se ferme : le rendre au burger (WCAG 2.4.3)
  const focusWasInside = mobileMenu.contains(document.activeElement);

  [header, icon, mobileMenu].forEach((el) => el.classList.remove("mm-open"));
  html.classList.remove("stop-scrolling");
  mobileMenu.setAttribute('aria-hidden', 'true');
  icon.setAttribute('aria-expanded', 'false');
  document.removeEventListener('keydown', mmMobileMenuKeydown);
  if (focusWasInside) icon.focus();

  // Optionnel : on peut nettoyer les styles inline si nécessaire
  //elements.mobileMenu.style.height = "";
  elements.mobileMenuInner && (elements.mobileMenuInner.style.top = "");
  mobileMenuSecondaryList.forEach(el => el.style.top = "");

  // Replier les panneaux ouverts : sans cela on rouvre le menu sur le dernier
  // panneau visité, dont l'en-tête se retrouve masquée derrière le header (le
  // décalage vertical est recalculé à l'ouverture, pas à la navigation).
  // On vise toutes les profondeurs, y compris les sous-panneaux de niveau 3
  // que `[data-menu-sublinks]` ne couvre pas.
  document
    .querySelectorAll(".mm-header-mobile-sublinks.mm-mobile-menu-elem-slided")
    .forEach((el) => {
      el.classList.remove("mm-mobile-menu-elem-slided");
      el._mmTrigger?.setAttribute('aria-expanded', 'false');
    });

  // if (!keepFilterActive) hideBgFilter();
  resetCssMobileContainer();
};


/**
 * Ouvre ou ferme le menu mobile depuis le bouton burger (clic et clavier).
 */
const mmToggleMobileMenu = () => {
  const mobileMenu = document.querySelector("[data-menu-mobile]");
  if (mobileMenu?.classList.contains("mm-open")) {
    mmCloseMobileMenu();
  } else {
    mmMobileMenu();
    mmHideSearch(false, true);
  }
};


/**
 * Show the next sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 * @param {HTMLElement} [trigger] - The button that opened it, focused back on return.
 */
const mmMobileMenuShowNext = (elemToShowClass, trigger) => {
	const container = document.querySelector("[data-menu-mobile] > .mm-mobile-menu-container");
	const panel = document.querySelector(elemToShowClass);
	container.style.overflowY = "visible";
	container.style.overflowX = "visible";
	if (!panel) return;
	panel.classList.add("mm-mobile-menu-elem-slided");
	if (trigger) {
		panel._mmTrigger = trigger;
		trigger.setAttribute('aria-expanded', 'true');
	}
	// Focus sur le bouton retour du sous-menu ouvert. preventScroll obligatoire : le panneau
	// est encore hors ecran (glissement), le focus faisait defiler le panneau parent
	// (overflow-x hidden, 308px) et tout le niveau 3 apparaissait decale.
	panel.querySelector(".mm-header-mobile-sublinks-return-arrow")?.focus({ preventScroll: true });
};

/**
 * Show the previous sub-menu in the mobile menu.
 *
 * @param {string} elemToShowClass - The CSS selector of the element to show.
 */
const mmMobileMenuShowPrev = (elemToShowClass) => {
	const panel = document.querySelector(elemToShowClass);
	if (!panel) return;
	panel.classList.remove("mm-mobile-menu-elem-slided");
	if (panel._mmTrigger) {
		panel._mmTrigger.setAttribute('aria-expanded', 'false');
		panel._mmTrigger.focus({ preventScroll: true });
	}
};

const MM_ANIM_MS = 800;
function resetCssMobileContainer() {
	const container = document.querySelector("[data-menu-mobile] > .mm-mobile-menu-container");
	if (!container) return;

	// si la fonction est rappelée pendant l'anim, on repart du dernier appel
	if (container._mmResetTO) clearTimeout(container._mmResetTO);

	container._mmResetTO = setTimeout(() => {
		container.style.removeProperty('overflow-y');
		container.style.removeProperty('overflow-x');
		container._mmResetTO = null;
	}, MM_ANIM_MS);
}

// DROPDOWN **********************************************************************************
/*********************************************************************************************
 * Handle dropdown behavior.
 *
 */
const handleDropdown = () => {
	// Helper pour récupérer le contenu associé à un dropdown
	const getContent = (el) => {
		const controlsId = el.getAttribute('aria-controls');
		return controlsId ? document.getElementById(controlsId) : el.nextElementSibling;
	};

	// Initialisation des dropdowns existants
	const initDropdowns = () => {
		const dropWrappers = document.querySelectorAll('[data-drop="dropdown"]');
		dropWrappers.forEach((item) => {
			// Skip si déjà initialisé
			if (item.dataset.dropInitialized) return;
			// Skip les dropdowns gérés par <mm-faq-dropdown> (custom element a son propre init)
			if (item.closest('mm-faq-dropdown')) return;
			item.dataset.dropInitialized = 'true';

			const content = getContent(item);
			if (!content) return;

			// Check if parent container has data-drop-first-open attribute
			const container = item.closest('[data-drop-first-open]');
			let shouldOpenFirst = false;

			if (container) {
				const containerDropdowns = container.querySelectorAll('[data-drop="dropdown"]');
				shouldOpenFirst = containerDropdowns[0] === item;
			}

			// Initial state
			if (!item.hasAttribute('aria-expanded')) {
				item.setAttribute('aria-expanded', shouldOpenFirst ? 'true' : 'false');
			}

			if (shouldOpenFirst) {
				item.classList.add('active');
				content.removeAttribute('hidden');
				requestAnimationFrame(() => {
					content.style.maxHeight = `${content.scrollHeight}px`;
				});
			} else if (!content.hasAttribute('hidden')) {
				content.setAttribute('hidden', '');
			}
		});
	};

	// Initialisation au chargement
	initDropdowns();

	// Délégation d'événements pour supporter les éléments dynamiques
	document.addEventListener('click', function(e) {
		const item = e.target.closest('[data-drop="dropdown"]');
		if (!item) return;

		// Ignorer les dropdowns gérés par <mm-faq-dropdown> (custom element a son propre handler)
		if (item.closest('mm-faq-dropdown')) return;

		const content = getContent(item);
		if (!content) return;

		// Fermer les autres dropdowns
		const allDropdowns = document.querySelectorAll('[data-drop="dropdown"]');
		allDropdowns.forEach((el) => {
			if (el !== item) {
				el.classList.remove("active");
				el.setAttribute('aria-expanded', 'false');
				const otherContent = getContent(el);
				if (otherContent) {
					otherContent.style.maxHeight = '0px';
					otherContent.setAttribute('hidden', '');
				}
			}
		});

		// Toggle ce dropdown
		item.classList.toggle("active");
		const isNowActive = item.classList.contains("active");
		item.setAttribute('aria-expanded', isNowActive.toString());

		if (isNowActive) {
			content.removeAttribute('hidden');
			requestAnimationFrame(() => {
				content.style.maxHeight = `${content.scrollHeight}px`;
			});
		} else {
			content.style.maxHeight = '0px';
			content.addEventListener('transitionend', () => {
				if (!item.classList.contains("active")) {
					content.setAttribute('hidden', '');
				}
			}, { once: true });
			// Fallback si transitionend ne se déclenche pas
			setTimeout(() => {
				if (!item.classList.contains("active")) {
					content.setAttribute('hidden', '');
				}
			}, 350);
		}
	});
};

// DROPDOWN 2 - MULTI DROPDOWN **************************************************************
/*********************************************************************************************
 * Handle dropdown-2 behavior - Multiple dropdowns can stay open simultaneously.
 * Utilisez data-drop="dropdown-2" pour ce comportement.
 *
 */
const handleDropdown2 = () => {
	// Helper pour récupérer le contenu associé à un dropdown
	const getContent = (el) => {
		const controlsId = el.getAttribute('aria-controls');
		return controlsId ? document.getElementById(controlsId) : el.nextElementSibling;
	};

	// Initialisation des dropdowns existants
	const initDropdowns2 = () => {
		const dropWrappers2 = document.querySelectorAll('[data-drop="dropdown-2"]');
		dropWrappers2.forEach((item) => {
			// Skip si déjà initialisé
			if (item.dataset.drop2Initialized) return;
			item.dataset.drop2Initialized = 'true';

			const content = getContent(item);
			if (!content) return;

			// Check if parent container has data-drop-first-open attribute
			const container = item.closest('[data-drop-first-open]');
			let shouldOpenFirst = false;

			if (container) {
				const containerDropdowns = container.querySelectorAll('[data-drop="dropdown-2"]');
				shouldOpenFirst = containerDropdowns[0] === item;
			}

			// Initial state
			if (!item.hasAttribute('aria-expanded')) {
				item.setAttribute('aria-expanded', shouldOpenFirst ? 'true' : 'false');
			}

			// Désactiver la navigation clavier dans le contenu fermé
			const focusableElements = content.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

			if (shouldOpenFirst) {
				item.classList.add('active');
				content.removeAttribute('hidden');
				content.removeAttribute('tabindex');
				focusableElements.forEach(el => el.removeAttribute('tabindex'));
				requestAnimationFrame(() => {
					content.style.maxHeight = `${content.scrollHeight}px`;
				});
			} else if (!content.hasAttribute('hidden')) {
				content.setAttribute('hidden', '');
				content.setAttribute('tabindex', '-1');
				focusableElements.forEach(el => el.setAttribute('tabindex', '-1'));
			}
		});
	};

	// Initialisation au chargement
	initDropdowns2();

	// Délégation d'événements pour supporter les éléments dynamiques
	document.addEventListener('click', function(e) {
		const item = e.target.closest('[data-drop="dropdown-2"]');
		if (!item) return;

		const content = getContent(item);
		if (!content) return;

		const focusableElements = content.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');

		// Version multi-dropdown : NE FERME PAS les autres dropdowns
		// Toggle seulement ce dropdown
		item.classList.toggle("active");
		const isNowActive = item.classList.contains("active");
		item.setAttribute('aria-expanded', isNowActive.toString());

		if (isNowActive) {
			// Ouvrir le dropdown - Activer la navigation clavier
			content.removeAttribute('hidden');
			content.removeAttribute('tabindex');
			focusableElements.forEach(el => el.removeAttribute('tabindex'));

			requestAnimationFrame(() => {
				content.style.maxHeight = `${content.scrollHeight}px`;
			});
		} else {
			// Fermer le dropdown - Désactiver la navigation clavier
			content.style.maxHeight = '0px';
			content.setAttribute('tabindex', '-1');
			focusableElements.forEach(el => el.setAttribute('tabindex', '-1'));

			content.addEventListener('transitionend', () => {
				if (!item.classList.contains("active")) {
					content.setAttribute('hidden', '');
				}
			}, { once: true });

			// Fallback si transitionend ne se déclenche pas
			setTimeout(() => {
				if (!item.classList.contains("active")) {
					content.setAttribute('hidden', '');
				}
			}, 350);

			// Garder le focus sur le bouton après fermeture
			setTimeout(() => {
				item.focus();
			}, 100);
		}
	});
};

// SEARCH ************************************************************************************
/**
 * Show the search bar on product page (mobile)
 * Reveals the hidden search container and shows predictive search default
 */
const mmShowSearchProduct = () => {
	const searchContainer = document.querySelector('.mm-header-search-center');
	if (!searchContainer) return;

	searchContainer.classList.remove('mm-none');
	searchContainer.classList.add('mm-flex');

	const searchInput = searchContainer.querySelector('input[type="search"]');
	if (searchInput) {
		// Focus triggers openOnFocus() in predictive-search.js
		// which shows predictive-search-default
		setTimeout(() => searchInput.focus(), 300);
	}
};

/**
 * Close the search bar on product page (mobile)
 * Hides the search container and closes predictive search while keeping mm-header-scroll
 */
const mmCloseSearchProduct = () => {
	const searchContainer = document.querySelector('.mm-header-search-center');
	const predictiveSearch = searchContainer?.querySelector('predictive-search');
	const header = document.querySelector(".mm-section-header");
	const isHomePage = document.body.classList.contains('template-index') ||
		document.body.classList.contains('index');

	if (!searchContainer) return;

	// Close predictive search panels manually (without calling closeSearch to preserve mm-header-scroll)
	const predictiveSearchDefault = predictiveSearch?.querySelector('.mm-ps-default');
	const predictiveSearchResults = predictiveSearch?.querySelector('.mm-ps-results');

	if (predictiveSearchDefault) {
		predictiveSearchDefault.style.display = 'none';
	}
	if (predictiveSearchResults) {
		predictiveSearchResults.style.display = 'none';
	}

	// Toggle icons: hide close button
	const closeIconActive = predictiveSearch?.querySelector('.mm-icon-close-input-close-active');
	const closeButton = predictiveSearch?.querySelector('.mm-search-close');

	if (closeIconActive) {
		closeIconActive.classList.remove('mm-active');
	}
	if (closeButton) {
		closeButton.style.display = 'none';
	}

	// Hide filter and enable scroll
	const filter = document.querySelector('[data-filter]');
	if (filter) {
		filter.classList.remove('active');
		filter.style.display = 'none';
	}
	document.documentElement.classList.remove('stop-scrolling');

	// Restore mm-header-scroll for non-homepage (product pages keep it)
	if (header && !isHomePage) {
		header.classList.add('mm-header-scroll');
	}

	// Hide search container
	searchContainer.classList.remove('mm-flex');
	searchContainer.classList.add('mm-none');

	// Clear input and update ARIA
	const searchInput = searchContainer.querySelector('input[type="search"]');
	if (searchInput) {
		searchInput.value = '';
		searchInput.setAttribute('aria-expanded', 'false');
		searchInput.blur();
	}
};

/**
 * Show the search bar and related UI changes.
 *
 * @param {HTMLElement} clickedElem - The element that was clicked to show the search bar.
 */
const mmShowSearch = () => {
	const elements = {
		search: document.querySelector("[data-search-container]"),
		html: document.documentElement,
		searchInput: document.querySelector("input.search-header"),
	};

     const search = document.querySelector('[data-search-container]');
     const menu = document.querySelector('.mm-header-secondary-menu');
      const searchIcon = document.querySelector('.mm-header-right .mm-header-icon-search');
      const positionIcon = document.querySelector('.mm-header-icon-position');
      const header = document.querySelector(".mm-section-header");

	if (Object.values(elements).some((el) => !el)) return;

     elements.html.classList.add('stop-scrolling');
     search.classList.add('mm-visible');
     menu.classList.add('mm-hidden');
      searchIcon.classList.add('mm-hidden');
      positionIcon.classList.add('mm-hidden');
      header.classList.add('mm-header-scroll');
      document.querySelector('.mm-header-search-backdrop')?.classList.add('mm-visible');

	elements.html.classList.add("stop-scrolling");
	elements.search.classList.add("mm-open");
	showBgFilter();

	setTimeout(() => elements.searchInput.focus(), 1000);

	document.querySelector(".mm-ps-results")?.addEventListener("touchstart", () => {
		setTimeout(() => elements.searchInput.blur(), 500);
	});
};

/**
 * Hide the search bar and revert UI changes.
 *
 * @param {HTMLElement} clickedElem - The element that was clicked to hide the search bar.
 */
const mmHideSearch = (keepFilterActive = false, keepStopScrolling = false) => {
	const elements = {
		search: document.querySelector("[data-search-container]"),
		html: document.documentElement,
		searchInput: document.querySelector("input.search-header"),
	};

     const search = document.querySelector('[data-search-container]');
     const menu = document.querySelector('.mm-header-secondary-menu');
      const searchIcon = document.querySelector('.mm-header-right .mm-header-icon-search');
      const positionIcon = document.querySelector('.mm-header-icon-position');
      const header = document.querySelector(".mm-section-header");

	if (Object.values(elements).some((el) => !el)) return;

     search.classList.remove('mm-visible');
     menu.classList.remove('mm-hidden');
      searchIcon.classList.remove('mm-hidden');
      positionIcon.classList.remove('mm-hidden');
      header.classList.remove('mm-header-scroll');
      document.querySelector('.mm-header-search-backdrop')?.classList.remove('mm-visible');

	if (!keepStopScrolling) {
		elements.html.classList.remove("stop-scrolling");
	}
	elements.search.classList.remove("mm-open");
	if (!keepFilterActive) hideBgFilter();

	elements.searchInput.value = "";
	elements.searchInput.dispatchEvent(new Event("input"));
};

// VIDEO *************************************************************************************
/**
 * Handles lazy loading of videos based on viewport size
 *
 */
const mmInitVideoLazy = () => {
	const videos = document.querySelectorAll(".mm-video-lazy");
	if (!videos.length) return;

	const loadVideo = (video) => {
		if (video.dataset.loaded !== "true") {
			const source = video.querySelector("source");
			if (!source || !source.dataset.src) return;

			source.src = source.dataset.src;
			video.preload = "metadata";
			video.dataset.loaded = "true";

			video.load();
			video.play().catch((err) => console.warn("Auto-play failed:", err));
		}
	};

	const unloadVideo = (video) => {
		if (video.dataset.loaded === "true") {
			video.pause();
			video.currentTime = 0;
			video.dataset.loaded = "false";
		}
	};

	const handleVideoVisibility = (video) => {
		const isMobile = window.matchMedia("(max-width: 768px)").matches;
		const isDesktop = video.classList.contains("mm-desktop");
		const isMobileVideo = video.classList.contains("mm-mobile");

		const shouldPlay = (!isDesktop && !isMobileVideo) || (isDesktop && !isMobile) || (isMobileVideo && isMobile);

		if (shouldPlay) {
			loadVideo(video);
			video.classList.add("mm-video-loaded");
		} else {
			video.classList.remove("mm-video-loaded");
		}
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					handleVideoVisibility(entry.target);
				} else {
					unloadVideo(entry.target);
				}
			});
		},
		{
			rootMargin: "50px 0px",
			threshold: 0.1,
		}
	);

	videos.forEach((video) => observer.observe(video));

	let resizeTimeout;
	window.addEventListener("resize", () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(() => {
			videos.forEach((video) => {
				if (video.classList.contains("mm-video-loaded")) {
					handleVideoVisibility(video);
				}
			});
		}, 250);
	});
};

// HEADER SCROLL EFFECT ********************************************************************
/**
 * Handle header scroll effect - change background and colors on scroll
 *
 */
const mmHeaderScrollEffect = () => {
	const header = document.querySelector("[data-mm-header]");
	const sectionHeader = document.querySelector("header.mm-section-header");

	// console.log("Header found:", header);
	// console.log("Section header found:", sectionHeader);

	if (!header) return;

	// Si on ne trouve pas la section header, on essaie de trouver le parent header
	let targetElement = sectionHeader;
	if (!targetElement) {
		targetElement = header.closest('header');
	}

	// console.log("Target element:", targetElement);
	// console.log("Current pathname:", window.location.pathname);
	// console.log("Body classes:", document.body.classList.toString());

	if (!targetElement) return;

	// Vérifier si on est sur la page d'accueil, un template page, ou le template club
	// MAIS exclure les templates product et store-locator
	const mainElement = document.querySelector('#MainContent');
	const isProductPage = document.body.classList.contains('template-product') ||
		(mainElement && mainElement.classList.contains('template-product'));
	const isStoreLocatorPage = window.location.pathname.includes('/pages/ou-nous-trouver') ||
		window.location.pathname.includes('/pages/store-locator') ||
		(mainElement && mainElement.classList.contains('template-page-store-locator'));
	const isHomePage = document.body.classList.contains('template-index') ||
		window.location.pathname === '/' ||
		window.location.pathname === '/index' ||
		window.location.pathname.includes('/pages/club');
	const isPageTemplate = ((mainElement && mainElement.classList.contains('template-page')) ||
		window.location.pathname.startsWith('/pages/')) &&
		!isStoreLocatorPage;

	const shouldHaveTransparentHeader = !isProductPage && !isStoreLocatorPage && isHomePage;

	// console.log("Is product page:", isProductPage);
	// console.log("Is store locator page:", isStoreLocatorPage);
	// console.log("Is home page:", isHomePage);
	// console.log("Is page template:", isPageTemplate);
	// console.log("Should have transparent header:", shouldHaveTransparentHeader);

	if (shouldHaveTransparentHeader) {
		// Ajouter l'attribut pour le CSS
		targetElement.setAttribute('data-transparent-header', 'true');

		// Sur ces pages : effet de scroll normal
		const handleScroll = () => {
			const scrollY = window.scrollY;
			const scrollThreshold = 50;

			if (scrollY > scrollThreshold) {
				targetElement.classList.add("mm-header-scroll");
			} else {
				targetElement.classList.remove("mm-header-scroll");
			}
		};

		// Initial check
		handleScroll();

		// Add scroll listener
		window.addEventListener("scroll", handleScroll, { passive: true });
	} else {
		// Sur les autres pages (dont product) : header toujours en état "scrollé"
		targetElement.classList.add("mm-header-scroll");
	}
};

// DOCUMENT HEIGHT ***************************************************************************
/**
 * Set the document height CSS variable to the current window height.
 *
 */
// Largeur de référence : on ne recalcule --doc-height que sur un vrai changement de largeur,
// pas à chaque variation de hauteur due à la barre d'URL mobile (qui provoque des sauts de scroll).
let lastViewportWidth = window.innerWidth;
const documentHeight = () => {
	document.documentElement.style.setProperty("--doc-height", `${window.innerHeight}px`);
};

// PRODUCT RECOMMENDATIONS *******************************************************************
/**
 * Custom element for product recommendations
 *
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement("div");
					html.innerHTML = text;

					// Chercher d'abord un product-recommendations dans la réponse (cas standard)
					let recommendations = html.querySelector("product-recommendations");

					// Si pas trouvé, chercher le contenu dans la section retournée (cas MM-Products-Slider)
					if (!recommendations || !recommendations.innerHTML.trim().length) {
						// Chercher le contenu dans .related-products ou .mm-splide-reco
						const relatedProducts = html.querySelector(".related-products") ||
						                       html.querySelector(".mm-splide-reco");
						if (relatedProducts) {
							recommendations = relatedProducts;
						}
					}

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;
						// Réinitialiser la wishlist pour les nouvelles cartes de produits
						if (window.wishlistManager) {
							window.wishlistManager.initButtons();
						}
						// Déclencher un événement personnalisé pour notifier que le contenu est chargé
						this.dispatchEvent(new CustomEvent('recommendations-loaded', { bubbles: true }));
					} else {
						const parentElement = this.closest(".mm-section");
						if (parentElement) {
							parentElement.style.display = "none";
						}
					}
				})
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), { rootMargin: "0px 0px 400px 0px" }).observe(this);
	}
}

customElements.define("product-recommendations", ProductRecommendations);

/*********************************************************************************************
 * Fonction pour splide
 */
/*********************************************************************************************
 * Fonction principale exécutée après le chargement du DOM
 */
function initializeSectionsWithSplide(attributeName, className, initializeFunction) {
    const sections = document.querySelectorAll(`[${attributeName}]`);

    sections.forEach(function (section) {
        const splideElem = section.querySelector(className);
        const attributeValue = section.getAttribute(attributeName);

        if (splideElem !== null && splideElem.querySelectorAll(".splide__slide").length > 0) {
            // Appel dynamique de la fonction passée en paramètre avec la valeur de l'attribut
            initializeFunction(splideElem, section, attributeValue);
        }
    });
}

/*********************************************************************************************
 * Fonction pour gérer le défilement horizontal
 */
function addHorizontalScrollListener(splideElem, splideInstance) {
    let accumulatedDeltaX = 0;
    let ticking = false;
    const stepThreshold = 60; // seuil pour déclencher un slide (~pixels de défilement)

    function processScroll() {
        ticking = false;
        const absDelta = Math.abs(accumulatedDeltaX);
        if (absDelta < stepThreshold) return;

        const steps = Math.floor(absDelta / stepThreshold);
        const direction = accumulatedDeltaX > 0 ? '>' : '<';

        for (let i = 0; i < steps; i++) {
            splideInstance.go(direction);
        }

        // Conserver le reste avec le bon signe pour un prochain cycle
        const sign = accumulatedDeltaX > 0 ? 1 : -1;
        accumulatedDeltaX = sign * (absDelta % stepThreshold);
    }

    splideElem.addEventListener('wheel', function (e) {
        // Ignorer si le défilement est principalement vertical
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            return;
        }

        const currentIndex = splideInstance.index;
        const length = splideInstance.length;
        const isScrollingRight = e.deltaX > 0;
        const isScrollingLeft = e.deltaX < 0;

        // Vérifier si un mouvement est possible dans la direction demandée
        let canMove = false;
        if (isScrollingRight) {
            // Essayer d'aller vers la droite
            const nextIndex = splideInstance.Components.Controller.getNext(true);
            canMove = nextIndex !== currentIndex && nextIndex < length;
        } else if (isScrollingLeft) {
            // Essayer d'aller vers la gauche
            const prevIndex = splideInstance.Components.Controller.getPrev(true);
            canMove = prevIndex !== currentIndex && prevIndex >= 0;
        }

        // Si aucun mouvement possible, laisser le scroll naturel
        if (!canMove) {
            accumulatedDeltaX = 0;
            return;
        }

        // Empêcher le défilement de la page quand on scroll horizontalement sur le carrousel
        e.preventDefault();

        // Reset si changement de direction (permet le retour arrière)
        if ((accumulatedDeltaX > 0 && e.deltaX < 0) || (accumulatedDeltaX < 0 && e.deltaX > 0)) {
            accumulatedDeltaX = 0;
        }

        // Accumuler le deltaX (trackpad/souris)
        accumulatedDeltaX += e.deltaX;

        if (!ticking) {
            ticking = true;
            requestAnimationFrame(processScroll);
        }
    }, { passive: false });
}


// DOM ***************************************************************************************
/**
 * Loaded Listenner
 *
 */
document.addEventListener("DOMContentLoaded", () => {
	getMegaMenuPosition();
	hoverBgFilter();
	externalLink();
	handleDropdown();
	handleDropdown2(); // Nouveau système multi-dropdown
	documentHeight();
	mmInitVideoLazy();

	// Délai pour s'assurer que tous les éléments sont chargés
	setTimeout(() => {
		mmHeaderScrollEffect();
		// Fix: Splide applies role="tabpanel" on <li> which is not allowed
		document.querySelectorAll('li.splide__slide[role]').forEach(function(slide) {
			slide.removeAttribute('role');
		});
	}, 100);
});

/**
 * Resized Listenner
 *
 */
let docHeightRaf;
window.addEventListener("resize", () => {
	// Ne réagir qu'à un vrai changement de largeur (rotation, redimensionnement).
	// Sur tablette/mobile, le scroll fait apparaître/disparaître la barre d'URL → events resize
	// en rafale (hauteur seule) : recalculer la position du mega-menu ou --doc-height ici
	// provoquait des reflows et des "sauts" du menu/scroll.
	if (window.innerWidth !== lastViewportWidth) {
		lastViewportWidth = window.innerWidth;
		getMegaMenuPosition();
		cancelAnimationFrame(docHeightRaf);
		docHeightRaf = requestAnimationFrame(documentHeight);
	}
});
